import { render } from "./CustomLoader.vue?vue&type=template&id=43d64822&scoped=true&lang=pug"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=43d64822&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/WP Darts/Admin Webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d64822"]])

export default __exports__